import React from "react";
import PropTypes from "prop-types";
import { Link, useStaticQuery, graphql } from "gatsby";

export const query = graphql`
  fragment StrapiSharedLink on StrapiComponentSharedLink {
    link {
      ...StrapiLink
    }
    overwriteTitle
    overwriteDescription
    overwriteIcon {
      ...StrapiMediaSubquery
    }
  }

  fragment StrapiLink on StrapiLink {
    url
    title
    description
    icon {
      ...StrapiMediaSubquery
    }
  }
`;

const isExternalURL = (url) => {
  try {
    return new URL(url).origin !== location.origin;
  } catch (error) {
    return null;
  }
};

function LinkWrapper({ children, to, isExternal = false, ...other }) {
  if (to === undefined || to === null) {
    return <div {...other}>{children}</div>;
  }
  // find url by strapiId
  const data = useStaticQuery(graphql`
    query links {
      links: allStrapiLink {
        nodes {
          url
          strapiId
        }
      }
    }
  `);
  const strapiLink = data?.links?.nodes?.find(
    (element) => element.strapiId == to
  );
  if (strapiLink) {
    to = strapiLink.url;
  }

  const isDownload = /^\/downloads\/.+/.test(to);
  if (isExternal || isExternalURL(to) || isDownload) {
    return (
      <a href={to} target="_blank" rel="noreferrer nofollow" {...other}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} {...other}>
      {children}
    </Link>
  );
}

LinkWrapper.propTypes = {
  props: PropTypes.object,
};

export default LinkWrapper;
